module.exports = __webpack_public_path__ + "static/home1-left-sidebar-a0b91a22edaa256b742b83339315212e.jpg";